import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.vfs;

const RefereeManagement = () => {

    const table1 = useRef(null);
    const table2 = useRef(null);
    const table3 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12, table13;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        if (table2.current) {
            table12 = $(table2.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        if (table3.current) {
            table13 = $(table3.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
            if (table13) table13.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Referee Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Referee Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            <ul className="nav nav-tabs inner-tab">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="all-tabs" data-bs-toggle="tab" data-bs-target="#allTab" type="button" role="tab">All</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pending-tabs" data-bs-toggle="tab" data-bs-target="#pendingTab" type="button" role="tab">Hired</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="onboarded-tabs" data-bs-toggle="tab" data-bs-target="#onboardedTab" type="button" role="tab">Requested</button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="allTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table1} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Experience level</th>
                                                    <th>Country</th>
                                                    <th>Games Count</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>John Clark</td>
                                                    <td>johnclark123@hotmail.com</td>
                                                    <td>Senior</td>
                                                    <td>USA</td>
                                                    <td>20</td>
                                                    <td>Pending</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Robert Sean</td>
                                                    <td>robertsean45@out.com</td>
                                                    <td>Intermediate</td>
                                                    <td>Canada</td>
                                                    <td>15</td>
                                                    <td>Approved</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Richard Thomas</td>
                                                    <td>richardthomas@hot.com</td>
                                                    <td>Junior</td>
                                                    <td>USA</td>
                                                    <td>12</td>
                                                    <td>Blocked</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pendingTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table2} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Experience level</th>
                                                    <th>Country</th>
                                                    <th>Games Count</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>John Clark</td>
                                                    <td>johnclark123@hotmail.com</td>
                                                    <td>Senior</td>
                                                    <td>USA</td>
                                                    <td>20</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Robert Sean</td>
                                                    <td>robertsean45@out.com</td>
                                                    <td>Intermediate</td>
                                                    <td>Canada</td>
                                                    <td>15</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Richard Thomas</td>
                                                    <td>richardthomas@hot.com</td>
                                                    <td>Junior</td>
                                                    <td>USA</td>
                                                    <td>12</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="onboardedTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table3} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Experience level</th>
                                                    <th>Country</th>
                                                    <th>Games Count</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>John Clark</td>
                                                    <td>johnclark123@hotmail.com</td>
                                                    <td>Senior</td>
                                                    <td>USA</td>
                                                    <td>20</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Robert Sean</td>
                                                    <td>robertsean45@out.com</td>
                                                    <td>Intermediate</td>
                                                    <td>Canada</td>
                                                    <td>15</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Richard Thomas</td>
                                                    <td>richardthomas@hot.com</td>
                                                    <td>Junior</td>
                                                    <td>USA</td>
                                                    <td>12</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/referee-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#block_referee_modal" type="button">
                                                                    <i className="bx bx-block" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Block" data-bs-original-title="Block" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#assign_game_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-joystick" aria-label="Game" title="Assign Game" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="block_referee_modal" tabIndex={-1} aria-labelledby="BlockRefereeModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="BlockRefereeModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to block this referee?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="assign_game_modal" tabIndex={-1} aria-labelledby="AssignGameModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="AssignGameModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <label className="form-label">Scheduled Games</label>
                            <select name="scheduledgames" className="form-select">
                                <option value="Team A vs Team B">Team A vs Team B</option>
                                <option value="Team A vs Team B">Team C vs Team D</option>
                                <option value="Team A vs Team B">Team E vs Team F</option>
                                <option value="Team A vs Team B">Team G vs Team H</option>
                            </select>
                        </div>
                        <div className="modal-footer">
                            {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button> */}
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Assign Game</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default RefereeManagement